import React from 'react';
import { withRouter } from 'react-router-dom';

import Popup from '../../Popup';

import styles from './welcomePopUps.scss';

const PlayerWelcomePopUp = (props) => {
    const {
        onCloseClick,
        onCtaClick,
        dashboard,
    } = props;

    return (
        <Popup
            className={`popup-md`}
            popUpClassName={`${styles.welcomePopUp}`}
            onCloseClick={onCloseClick}
            config={{
                noPadding: true,
                fullScreen: false,
                topGradient: false,
                scrollable: false,
            }}
            data-testid="modal.player-welcome"
        >
            <div className={`${styles.section} pt0 pb8`}>
                <h3 data-testid="modal.player-welcome.heading">{`Welcome ${dashboard.member.firstName},`}</h3>
            </div>
            <div className={`${styles.section} pt36`}>
                <div className={`mb24`}>
                    <h5 className={`mb24`} data-testid="modal.player-welcome.subtitle">
                        What’s next?
                    </h5>
                    <ul className="text-dark" data-testid="modal.player-welcome.features-list">
                        <li data-testid="modal.player-welcome.feature-find-players">Find players by location, segment, rating and more</li>
                        <li data-testid="modal.player-welcome.feature-discover-events">Discover and register for nearby events</li>
                        <li data-testid="modal.player-welcome.feature-message">Message players, coaches and organizers</li>
                        <li data-testid="modal.player-welcome.feature-post-scores">Post scores from your individual match play</li>
                        <li data-testid="modal.player-welcome.feature-showcase">Showcase your profile with photos/videos</li>
                    </ul>
                </div>
                <div className="mt48">
                    <button
                        type="button"
                        className="btn btn-primary btn-xl btn-block text-uppercase"
                        onClick={(ev) => {
                            onCtaClick(ev);
                        }}
                        data-testid="modal.player-welcome.cta-btn"
                    >
                        Next: Go to my Dashboard
                    </button>
                </div>
            </div>
        </Popup>
    );
};

export default withRouter(PlayerWelcomePopUp);
